import { useState, useEffect } from 'react';
import { Button, Checkbox, Form, Image, Modal, Typography, Divider, Spin } from 'antd';
import PropTypes from 'prop-types';
import BoxImg from '../../../../assets/images/box2.png';
import { getRentalTerms } from '../../../../data/API';
import './index.css';

const { Title, Paragraph, Text } = Typography;

const TermsServiceModal = ({ visible, onClose, onAccept }) => {
  const [agreedTerms, setAgreedTerms] = useState(false);
  const [termsContent, setTermsContent] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible) {
      fetchRentalTerms();
    }
  }, [visible]);

  const fetchRentalTerms = async () => {
    try {
      setLoading(true);
      const response = await getRentalTerms();
      if (response.data?.results && response.data.results.length > 0) {
        const content = response.data.results[0].rental_terms_content || '';
        setTermsContent(content);
      }
    } catch (error) {
      console.error('Error fetching rental terms:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAccept = () => {
    onAccept(true);
    onClose();
  };

  const handleDecline = () => {
    onAccept(false);
    onClose();
  };

  const onAgreedTerms = (e) => {
    setAgreedTerms(e.target.checked);
  };



  return (
    <Modal
      title={null}
      open={visible}
      onCancel={onClose}
      width={600}
      className="terms-modal-container"
      footer={
        <div className="terms-modal-footer">
          <Button 
            size="medium" 
            onClick={handleDecline}
            className="terms-cancel-btn"
            type="default"
          >
            Cancel
          </Button>
          <Button 
            type="primary" 
            size="medium" 
            onClick={handleAccept}
            className="terms-okay-btn"
            disabled={!agreedTerms}
          >
            Okay
          </Button>
        </div>
      }
    >
      <div className="terms-modal-content">
        <div className="hiw-header">
          <div className="d-flex justify-content-center">
            <div className="header-content">
              <p className="text-white text-header mb-0">Please review and agree to our Moving Box Rental Terms & Conditions</p>
            </div>
            <div className="header-image">
              <Image
                className="main-image"
                src={BoxImg}
                preview={false}
                alt="storage_header_image"
              />
            </div>
          </div>
        </div>

        {loading ? (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <Spin size="large" />
          </div>
        ) : termsContent ? (
          <div className="terms-content-wrapper">
            <div dangerouslySetInnerHTML={{ __html: termsContent }} />
            
            <div className="terms-agreement-section">
              <Form layout="vertical" autoComplete="off">
                <Form.Item noStyle>
                  <Checkbox 
                    className="terms-agree-checkbox" 
                    checked={agreedTerms} 
                    onChange={onAgreedTerms}
                  >
                    I agree to{' '}
                    <span className="terms-link-text">BlueBox terms</span> of service
                  </Checkbox>
                </Form.Item>
              </Form>
            </div>
          </div>
        ) : (
          <div className="terms-content-wrapper">
            <p style={{ textAlign: 'center', color: '#666', padding: '40px' }}>
              No terms and conditions available at the moment.
            </p>
            
            <div className="terms-agreement-section">
              <Form layout="vertical" autoComplete="off">
                <Form.Item noStyle>
                  <Checkbox 
                    className="terms-agree-checkbox" 
                    checked={agreedTerms} 
                    onChange={onAgreedTerms}
                  >
                    I agree to{' '}
                    <span className="terms-link-text">BlueBox terms</span> of service
                  </Checkbox>
                </Form.Item>
              </Form>
            </div>
          </div>
        )}

      </div>
    </Modal>
  );
};

TermsServiceModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onAccept: PropTypes.func.isRequired
};

export default TermsServiceModal;